
import Shop from "@/models/general/settings/RoadcubeMarket/Shop";

export default {
    namespaced: true,

    state: () => ({
        products: [],
        
    }),

    mutations: {

        setProducts(state, payload) {
            state.products = payload || [];
        },

    },

    actions: {

        async getShopProducts({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Shop.getShopProducts();
                commit("setProducts", data?.data?.subscription_products || [])
                
                commit("setLoading", false, { root: true });
            } catch (ex) {                
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },
        
        async buyShopProducts({ commit, state, dispatch }, body) {
            try {
                commit("setLoading", true, { root: true });
                let res
                if (body.threshold) {
                    res = await Shop.buyShopThresholdProduct(body);
                }else{
                    res = await Shop.buyShopProducts(body);
                }
                commit("setLoading", false, { root: true });
                return res.data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response?.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
    }
};
